module.exports = __webpack_public_path__ + "static/media/not-blocked.21538ed5.svg";